/* React base class */
import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Shared utilities (phone formatting) */
import { utils } from "../helpers"

/* UI components */
import Icon from "../components/Icon"
import Logo from "../components/Logo"

/* Auth API: request, verify, save and resend OTP */
import { request, verify, save, resend } from "../api/Auth"

/* Translation */
import { translate } from "../translates"

/* Widget Authorization */
class Authorization extends Component {

    constructor(props) {
        super(props)
        /* State */
        this.state = {
            step: "phone",
            phone: "+7",
            code: ["", "", "", ""],
            name: "",
            email: "",
            resendIn: 58,
            loading: false,
            error: null
        }
    }

    /* Refs to the four OTP inputs */
    refs2 = []
    /* Resend countdown interval handle */
    timer = null

    componentWillUnmount = () => {
        this.stop()
    }

    /* Resend countdown */
    start = () => {
        this.stop()
        this.setState({ resendIn: 58 })
        this.timer = setInterval(() => {
            this.setState((state) => {
                if (state.resendIn <= 1) {
                    this.stop()
                    return { resendIn: 0 }
                }
                return { resendIn: state.resendIn - 1 }
            })
        }, 1000)
    }

    stop = () => {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    }

    /* Draw Close */
    _close = () => {
        this.stop()
        this.setState({ step: "phone", phone: "+7", code: ["", "", "", ""], name: "", email: "", error: null, loading: false })
        this.props.toggle(false)
    }

    /* Draw On Phone */
    _onPhone = (event) => {
        this.setState({ phone: utils.phone(event.target.value), error: null })
    }

    /* Draw Request */
    _request = () => {
        if (this.state.phone.replace(/\D/g, "").length < 11) {
            return
        }
        this.setState({ loading: true, error: null })
        request(this.state.phone).then((response) => {
            if (response && response.status === 200) {
                this.setState({ step: "code", loading: false }, () => {
                    this.start()
                    setTimeout(() => { if (this.refs2[0]) this.refs2[0].focus() }, 60)
                })
            }
            else {
                this.setState({ loading: false, error: translate("Не удалось отправить код") })
            }
        })
    }

    /* Draw On Code */
    _onCode = (index, value) => {
        const digit = value.replace(/\D/g, "").slice(-1)
        const code = [...this.state.code]
        code[index] = digit
        this.setState({ code, error: null })
        if (digit && index < 3 && this.refs2[index + 1]) {
            this.refs2[index + 1].focus()
        }
        if (code.every((item) => item)) {
            this._verify(code.join(""))
        }
    }

    /* Draw On Code Key */
    _onCodeKey = (index, event) => {
        if (event.key === "Backspace" && !this.state.code[index] && index > 0 && this.refs2[index - 1]) {
            this.refs2[index - 1].focus()
        }
    }

    /* Draw Verify */
    _verify = (code) => {
        this.setState({ loading: true })
        verify(this.state.phone, code).then((response) => {
            if (response && response.status === 200 && response.data.token) {
                this._success(response.data)
            }
            else if (response && response.status === 200 && response.data.status === "name_required") {
                this.setState({ step: "name", loading: false })
            }
            else {
                this.setState({ loading: false, code: ["", "", "", ""], error: translate("Неверный код") }, () => {
                    if (this.refs2[0]) this.refs2[0].focus()
                })
            }
        })
    }

    /* Draw Resend */
    _resend = () => {
        resend(this.state.phone).then(() => {
            this.setState({ code: ["", "", "", ""] })
            this.start()
        })
    }

    /* Draw Save */
    _save = () => {
        if (this.state.name.trim().length < 2) {
            this.setState({ error: translate("Укажите имя") })
            return
        }
        this.setState({ loading: true, error: null })
        save({ phone: this.state.phone, code: this.state.code.join(""), name: this.state.name.trim(), email: this.state.email.trim() || null }).then((response) => {
            if (response && response.status === 200 && response.data.token) {
                this._success(response.data)
            }
            else {
                this.setState({ loading: false, error: translate("Не удалось сохранить") })
            }
        })
    }

    /* Draw Success */
    _success = (data) => {
        this.props.addToken(data.token)
        this.props.addUser(data.user)
        this._close()
    }

    render = () => {
        if (!this.props.open) {
            return null
        }

        const canContinue = this.state.phone.replace(/\D/g, "").length >= 11

        return (
            <div className="modal-backdrop modal-backdrop--top" onClick={this._close}>
                <div className="modal modal--sm" onClick={(e) => e.stopPropagation()}>
                    <button className="modal__close" onClick={this._close} style={{ position: "absolute", top: 16, right: 16 }} aria-label={translate("Закрыть")}>
                        <Icon name="close" size={20} />
                    </button>

                    <div className="auth">
                        <Logo size={56} className="auth__logo-img" />

                        {this.state.step === "phone" && (
                            <>
                                <h2 className="auth__title" style={{ marginTop: 28 }}>{translate("Вход")}</h2>
                                <p className="auth__lede">
                                    {translate("Чтобы продолжить, введите номер телефона —")}<br />
                                    {translate("мы отправим код подтверждения в WhatsApp или SMS.")}
                                </p>
                                <div className="auth__field">
                                    <label className="field__label">{translate("Телефон")}</label>
                                    <input className="input" value={this.state.phone} onChange={this._onPhone} placeholder="+7 (___) ___-__-__" inputMode="tel" autoFocus />
                                </div>
                                {this.state.error && <p className="auth__lede" style={{ color: "var(--danger)" }}>{this.state.error}</p>}
                                <button className="btn btn--block btn--lg" disabled={!canContinue || this.state.loading} style={{ opacity: canContinue ? 1 : 0.5, marginTop: 8 }} onClick={this._request}>
                                    {this.state.loading ? translate("Отправляем…") : translate("Продолжить")}
                                </button>
                                <p className="auth__terms">
                                    {translate("Нажимая кнопку «Продолжить», вы соглашаетесь с")}{" "}
                                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">{translate("Политикой конфиденциальности")}</a>
                                    {" "}{translate("и")}{" "}
                                    <a href="/public-offer" target="_blank" rel="noopener noreferrer">{translate("Публичной офертой")}</a>
                                </p>
                            </>
                        )}

                        {this.state.step === "code" && (
                            <>
                                <h2 className="auth__title" style={{ marginTop: 28 }}>{translate("Подтвердите телефон")}</h2>
                                <p className="auth__lede">
                                    {translate("Мы отправили код подтверждения")}<br />
                                    {translate("на номер")} <b style={{ color: "var(--ink)" }}>{this.state.phone}</b>
                                </p>
                                <div style={{ marginBottom: 8, fontSize: 12, color: "var(--muted)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                                    {translate("Введите 4-значный код")}
                                </div>
                                <div className="otp-boxes">
                                    {this.state.code.map((c, index) => (
                                        <input
                                            key={`${index}`}
                                            ref={(element) => (this.refs2[index] = element)}
                                            className={`otp-box ${c ? "is-filled" : ""}`}
                                            value={c}
                                            onChange={(event) => this._onCode(index, event.target.value)}
                                            onKeyDown={(event) => this._onCodeKey(index, event)}
                                            inputMode="numeric"
                                            maxLength={1}
                                        />
                                    ))}
                                </div>
                                {this.state.loading && <p className="otp-resend">{translate("Проверяем код…")}</p>}
                                {this.state.error && <p className="otp-resend" style={{ color: "var(--danger)" }}>{this.state.error}</p>}
                                <p className="otp-resend">
                                    {this.state.resendIn > 0 ? (
                                        <>{translate("Повторная доставка кода будет доступна через")} <b style={{ color: "var(--ink)" }}>{this.state.resendIn} {translate("сек")}</b></>
                                    ) : (
                                        <a href="#" onClick={(e) => { e.preventDefault(); this._resend() }}>{translate("Отправить код повторно")}</a>
                                    )}
                                </p>
                                <button onClick={() => this.setState({ step: "phone", code: ["", "", "", ""] })} style={{ marginTop: 16, color: "var(--muted)", fontSize: 13, fontWeight: 600 }}>
                                    ← {translate("Изменить номер")}
                                </button>
                            </>
                        )}

                        {this.state.step === "name" && (
                            <>
                                <h2 className="auth__title" style={{ marginTop: 28 }}>{translate("Как вас зовут?")}</h2>
                                <p className="auth__lede">{translate("Завершите регистрацию — имя видят организации при записи.")}</p>
                                <div className="auth__field">
                                    <label className="field__label">{translate("Ваше имя")}</label>
                                    <input className="input" value={this.state.name} onChange={(event) => this.setState({ name: event.target.value, error: null })} placeholder={translate("Ваше имя")} autoFocus />
                                </div>
                                <div className="auth__field">
                                    <label className="field__label">{translate("Email (необязательно)")}</label>
                                    <input className="input" value={this.state.email} onChange={(event) => this.setState({ email: event.target.value })} placeholder="hello@bookify.kz" />
                                </div>
                                {this.state.error && <p className="auth__lede" style={{ color: "var(--danger)" }}>{this.state.error}</p>}
                                <button className="btn btn--block btn--lg" disabled={this.state.loading} style={{ marginTop: 8 }} onClick={this._save}>
                                    {this.state.loading ? translate("Сохраняем…") : translate("Готово")}
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        open: state.auth,
        lang: state.lang
    }
}

/* Map Dispatch To Props */
const mapDispatchToProps = dispatch => {
    return {
        toggle: data => dispatch({ type: "TOGGLE_AUTH", payload: data }),
        addToken: data => dispatch({ type: "ADD_TOKEN", payload: data }),
        addUser: data => dispatch({ type: "ADD_USER", payload: data })
    }
}

/* Export */
export default connect(mapStateToProps, mapDispatchToProps)(Authorization)
